<div #detailContainer class="modal--background" *ngIf="visible" (click)="closeDialog()">
  <div class="container">
    <div class="modal--container" (click)="stopBubbling($event)">
      <app-detail (closeDetail)="closeDialog()"></app-detail>
    </div>
  </div>
</div>
